<template>
  <keep-alive>
    <transition name="slide-fade">
      <div class="holidayBookMore">
        <BannerTop
          id="bannerTop"
          title="假期作业"
          :sticky="true"
          style="z-index: 100"
          :show-icon-right="false"
        >
          <template v-slot:right>
            <div class="top_slot" @click="handleClick('showModal')">筛选</div>
          </template>
        </BannerTop>
        <!-- 筛选 -->
        <div v-if="showModal" class="popup_overlay" @click="handleClick('close')">
          <div ref="popup_cont" class="popup_cont flex-col flex-jc-bt" @click.stop>
            <div>
              <div class="popup_cont_title">版本</div>
              <div class="flex-row-wrap">
                <div
                  v-for="(item, index) in showVersion"
                  :key="index"
                  class="popup_cont_item flex-row flex-center"
                  :class="{ popup_cont_item_active: activeList.indexOf(item.chName) > -1 }"
                  @click="versionClick(item, index)"
                >
                  {{ item.chName }}
                </div>
              </div>
            </div>
            <div class="flex-row popup_cont_btns">
              <div @click="handleClick('enter')">确定</div>
              <div class="popup_cont_btns-reset" @click="handleClick('reset')">重置</div>
            </div>
          </div>
        </div>
        <!-- 书籍列表 -->
        <div class="holidayBookMore_bookList">
          <div v-for="(list, key) in splitGroupData" :key="key" class="booktype">
            <div class="header" :class="`course_${key === '数学' ? 2 : key === '语文' ? 1 : 3}`">
              <h1 class="title">
                <!--        <span class="before"></span>-->
                <span>{{ key }}</span>
              </h1>
            </div>
            <Grid
              class="list"
              :cols="3"
              col-margin="0.43rem"
              row-margin="0.736rem"
              :class="$style.list"
            >
              <GridItem v-for="(item, index) in list" :key="index" class="item">
                <div v-if="item" class="book">
                  <Book
                    class="book__cover"
                    :book-name="item.name || item.abbrName"
                    :book-edition="item.versionName"
                    :book-status="item"
                    :book-img="$env.ossUrl(item.thumbCoverPath)"
                    :effective-date="item.onlineTime || item.createTime"
                    :describe="false"
                    hideNewBrage
                  />
                  <div>
                    <div v-if="item.category === 'keben'" class="book__name">
                      {{ courseName(item.book.course) }}{{ item.name || item.abbrName }}
                    </div>
                    <div v-else class="book__name">{{ item.name || item.abbrName }}</div>
                    <div class="book__edition">{{ item.versionName }}</div>
                  </div>
                </div>
              </GridItem>
            </Grid>
          </div>
        </div>
        <div v-if="deficiency" class="quesheng">
          <img
            style="width: 168px; height: 168px; display: inline-block"
            src="https://img01.yzcdn.cn/upload_files/2021/02/08/FlkIEH_-HEmGfRtxs23-5eenqTv9.png"
          />
          <p class="title">此筛选条件下没有书籍资源 换个版本试试吧～</p>
        </div>
      </div>
    </transition>
  </keep-alive>
</template>

<script>
/*
 * By Suxue
 * 2021/12/24
 */
import BannerTop from '@/components/BannerTop'
import { getPlatform } from '@/static/js/zjs'
import Grid from '@/components/Grid'
import GridItem from '@/components/Grid/GridItem'
import Book from '@/pages/answer/component/book'
export default {
  name: 'MoreHolidayBook',
  components: { GridItem, Grid, BannerTop, Book },
  data() {
    return {
      showModal: false,
      versionData: [],
      selected: [],
      selecteds: [],
      undfoldSeleced: [],
      bookList: [],
      item: {
        name: 'sss',
        versionName: 'sdasda'
      },
      deficiency: false
    }
  },
  computed: {
    // 从总数据中筛选出指定版本，即为展示数据
    showData() {
      if (!this.bookList) {
        return []
      }
      if (this.selecteds.length <= 0) {
        return this.bookList
      } else {
        return this.bookList.filter(
          (item) => this.undfoldSeleced.findIndex((item1) => +item1.value === +item.version) > -1
        )
      }
    },
    splitGroupData() {
      const showData = this.showData
      const sort = [2, 1, 3, 4]
      return sort.reduce((prev, curr) => {
        const data = showData.filter((i) => i.course === curr)
        if (data.length > 0) {
          prev[data[0].courseName] = data
        }
        return prev
      }, {})
    },
    // 选中的项目，控制样式
    activeList() {
      //   if (this.selected.length === this.showVersion.length) {
      //     return [];
      //   }
      return this.selected.map((item) => item.chName)
    },
    // 版本展示
    showVersion() {
      return this.versionData
    }
  },
  mounted() {
    this.$store.dispatch('holidayBook/dispatch_getHolidayBookList').then((res) => {
      this.bookList = res
    })
    this.getVerisonData().then((versionData) => {
      const temp = this.changeVersion(this.addSelected(versionData))
      // this.initUserVersion(temp)
      this.versionData = temp
    })
  },
  methods: {
    // 添加选择需要的数据
    addSelected(versionData) {
      return versionData.map((item) => {
        item.selected = JSON.parse(JSON.stringify(item))
        return item
      })
    },
    // 语文课本修改版本展示
    changeVersion(versionData = []) {
      // const temp = versionData.filter((item) => ['人教版', '部编版'].indexOf(item.chName) < 0)
      // const temp2 = versionData.filter((item) => ['人教版', '部编版'].indexOf(item.chName) > -1)
      // if (temp2.length > 0) {
      //   temp.unshift({
      //     id: temp2.map((item) => item.id),
      //     chName: '人教/部编版',
      //     selected: temp2
      //   })
      // }
      return versionData
    },
    // 版本选择点击函数，多选
    versionClick(item, index) {
      const find = this.selected.findIndex((val) => val.chName === item.chName)
      // 再次点击取消
      if (find > -1) {
        this.selected.splice(find, 1)
      } else {
        this.selected.push(item)
      }
    },
    // 事件分发
    handleClick(event, data) {
      switch (event) {
        case 'showModal': {
          this.showModal = !this.showModal
          if (this.showModal) {
            this.$nextTick(() => {
              this.$refs['popup_cont'].style.width = '75%'
            })
          }
          break
        }
        case 'close': {
          this.showModal = false
          break
        }
        case 'enter': {
          this.undfoldSeleced = this.selected.reduce((prev, curr) => {
            if (curr.selected && curr.selected.length) {
              prev = [...prev, ...curr.selected]
            } else {
              prev.push(curr.selected)
            }
            return prev
          }, [])
          this.selecteds = [...this.selected]
          if (this.showData.length === 0) {
            this.deficiency = true
          } else {
            this.deficiency = false
          }
          this.showModal = false
          break
        }
        case 'reset': {
          this.selected = []
          this.selecteds = [...this.selected]
          if (this.showData.length === 0) {
            this.deficiency = true
          } else {
            this.deficiency = false
          }
          break
        }
      }
    },
    // 获取版本数据
    async getVerisonData() {
      const appid = getPlatform().appid
      const key = `answercard.holidaybook.${appid}.version`
      return this.$store.dispatch('dictionary/getDictionaryData', [key]).then((data) => {
        return data[key]
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.3s ease;
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(100%);
}
.holidayBookMore {
  min-height: 100vh;
  overflow: auto;
  background: #ffffff;
  .top_slot {
    font-size: 14px;
    color: #333333;
  }
  .popup_overlay {
    position: fixed;
    right: 0;
    left: 0;
    bottom: 0;
    top: 40px;
    height: 100vh;
    background: rgba(0, 0, 0, 0.3);
    z-index: 8;
    .popup_cont {
      position: absolute;
      height: 100vh;
      width: 0;
      left: 25%;
      background: #ffffff;
      padding-left: 8px;
      .popup_cont_title {
        margin-bottom: 5px;
        margin-left: 12px;
        color: #333333;
        font-size: 14px;
        font-weight: bold;
        margin-top: 16px;
      }
      .popup_cont_item {
        width: 76px;
        height: 28px;
        margin: 8px 6px;
        background: #f5f5f5;
        border-radius: 146px;
        font-size: 12px;
        color: #333333;
      }
      .popup_cont_item_active {
        background: #ff2638;
        border-radius: 146px;
        color: #ffffff;
      }
      .popup_cont_btns {
        margin-bottom: 88px;
        padding: 0 16px 0 8px;
        display: flex;
        justify-content: space-between;
        div {
          //flex: 1;
          text-align: center;
          font-size: 14px;
          border-radius: 50px;
          width: 107px;
          height: 43px;
          line-height: 43px;
        }
        div:first-child {
          background: #ff2638;
          color: #ffffff;
        }
        .popup_cont_btns-reset {
          background: #ffffff;
          border: 0.5px solid #cdcccc;
          box-sizing: border-box;
          border-radius: 50px;
        }
        // div:last-child {
        //   background: #ffffff;
        //   border: 0.5px solid #cdcccc;
        //   box-sizing: border-box;
        //   border-radius: 50px;
        // }
      }
    }
  }

  .holidayBookMore_bookList {
    .booktype {
      margin: 12px 10px;
      padding: 0 0 12px;
      background: #ffffff;
      border: 0.5px solid #f3f6f9;
      box-sizing: border-box;
      box-shadow: 0px 6px 16px rgba(0, 0, 0, 0.04);
      border-radius: 6px;
    }
    .header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 15px 14px 6px;
      border-radius: 6px;
      &.course_1 {
        background: linear-gradient(180deg, #fff3f3 0%, rgba(255, 255, 255, 0) 68.75%);
      }
      &.course_2 {
        background: linear-gradient(180deg, #f1f5ff 0%, #ffffff 100%);
      }
      &.course_3 {
        background: linear-gradient(180deg, #effff5 0%, #ffffff 100%);
      }
      .title {
        display: flex;
        align-items: center;

        span {
          font-size: 16px;
          font-family: PingFang SC;
          font-style: normal;
          color: #333;
          font-weight: 800;
        }
        .before {
          display: block;
          content: '';
          width: 26px;
          height: 28px;
          background: url(https://img.yzcdn.cn/upload_files/2020/06/23/Frlmiq7xxVpSrIRFe9wuuo7cSuiL.png)
            no-repeat;
          background-size: contain;
        }
      }
    }

    .item {
      overflow: hidden;
      text-align: left;
      display: flex;
      justify-content: center;
      .book__cover {
        box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
      }
      .book__name {
        margin-top: 0.29rem;
        font-size: 0.37rem;
        // height: 37px;
        color: rgba(51, 51, 51, 1);
        font-weight: 500;
        // font-style: normal;
        width: 100%;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        overflow: hidden;
        /*! autoprefixer: off */
        -webkit-box-orient: vertical;
      }
      .book__edition {
        margin-top: 0.21rem;
        font-size: 0.32rem;
        font-weight: 400;
        color: #b2b2b2;
        white-space: nowrap;
        word-break: none;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
  }
}
.quesheng {
  text-align: center;
  position: absolute;
  top: 122px;
  left: 50%;
  transform: translate(-50%);
  .title {
    width: 168px;
    color: #999999;
    font-size: 14px;
  }
}
.list {
  padding: 0 13px;
}
</style>

<style lang="scss" module>
.list {
  :global(.book-img) {
    height: calc((33.3vw - 35px) * 1.4);
    display: block;
    border: 0;
  }
}
</style>